import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=a22470b6"
import script from "./Concepts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Concepts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Concepts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxEsgMeasureEdit: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/esgMeasureEdit.vue').default,IxDataTableConcepts: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Concepts.vue').default,IxDataTableAuditLogs: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/AuditLogs.vue').default,IxDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Dialog.vue').default,IxSearchText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SearchText.vue').default})
